module.exports = {"devServerApi":"http://localhost:11777","stageServerApi":"https://moowle-dev.appspot.com","prodServerApi":"https://appengine.moowle.com","prodProphetApi":"https://prophet.moowle.com/api","stageProphetApi":"https://prophet-stage.moowle.com/api","devCloudFunctionBase":"http://localhost:8080","stageCloudFunctionBase":"https://europe-west1-moowle-dev.cloudfunctions.net","prodCloudFunctionBase":"https://europe-west1-maakler-178918.cloudfunctions.net"}


//////////////////
// WEBPACK FOOTER
// ./src/config/envDetails.json
// module id = uS6d
// module chunks = 1